var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_c('a-pagination',{attrs:{"total":_vm.total,"current":_vm.current,"show-less-items":"","defaultPageSize":_vm.pageSize,"pageNum":_vm.pageNum},on:{"change":_vm.handlePagination}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19038804","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/public/AntdvPagination.vue
// module id = null
// module chunks = 